import {
  ConsolidatedStatus,
  getConsolidatedStatusColor,
  getConsolidatedStatusDisplayText,
} from '@modules/UserStatusModule/utilities/ConsolidatedStatus/ConsolidatedStatus';
import { Icon } from '@servicetitan/anvil2';
import CallInbound from '@servicetitan/anvil2/assets/icons/st/call_inbound.svg';
import { StaticStatusLight } from '../StaticStatusLight';

export const ConsolidatedUserStatusIndicator = ({
  consolidatedStatus,
  hasOfferedCall,
  className,
  'data-testid': dataTestId,
}: {
  consolidatedStatus: ConsolidatedStatus;
  hasOfferedCall?: boolean;
  className?: string;
  'data-testid'?: string;
}) => {
  return (
    <StaticStatusLight
      color={getConsolidatedStatusColor(consolidatedStatus)}
      data-testid={dataTestId || 'consolidated-status'}
      className={className}
    >
      {getConsolidatedStatusDisplayText(consolidatedStatus)}
      {hasOfferedCall && <Icon svg={CallInbound} size='medium' />}
    </StaticStatusLight>
  );
};
